import { Component, EventEmitter, inject, Output } from '@angular/core';
import { Button } from 'primeng/button';
import { AppService } from '../../../services/app.service';
import { MenuType } from '../../../enum/app.enum';

@Component({
  selector: 'app-mobile-menu-drawer',
  imports: [Button],
  templateUrl: './mobile-menu-drawer.html',
  styleUrl: './mobile-menu-drawer.scss',
  standalone: true
})
export class MobileMenuDrawer {
  @Output() changedHeight = new EventEmitter<number>();
  public appService = inject(AppService);

  scrollToMenuSection(menu: MenuType) {
    this.appService.menuDrawer = false;
    this.appService.goToSection(menu);
  }
}
